import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4e61c83c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "wrapper" }
const _hoisted_2 = { class: "container" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_fa_icon = _resolveComponent("fa-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("button", {
        class: "close",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onCancel && _ctx.onCancel(...args)))
      }, [
        _createVNode(_component_fa_icon, {
          icon: "times",
          size: "lg"
        })
      ]),
      _createElementVNode("div", {
        class: "white-ball",
        id: "white-ball-big-id",
        onMouseenter: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.mouseEnter && _ctx.mouseEnter(...args))),
        onMousemove: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.mouseMove && _ctx.mouseMove(...args))),
        onMouseleave: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.mouseLeave && _ctx.mouseLeave(...args))),
        onMouseup: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.mouseUp && _ctx.mouseUp(...args))),
        onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.ballMouseDown && _ctx.ballMouseDown(...args)))
      }, [
        _createElementVNode("span", {
          class: "strike-marker-big-icon",
          id: "strike-marker-big-icon",
          draggable: "true",
          onMousedown: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.mouseDown && _ctx.mouseDown(...args)))
        }, " + ", 32)
      ], 32)
    ])
  ]))
}